import { useQuery } from "@tanstack/react-query"
import { getPayments } from "@/lib/api/order.api"
import { useAuthStore } from "@/store/auth.store"

export function useGetPayments(orderId: string, enabled: boolean = true) {
  const accessToken = useAuthStore((s) => s.accessToken)

  return useQuery({
    queryKey: ["order-payments", orderId],
    queryFn: () => getPayments(orderId, accessToken!),
    enabled: !!accessToken && !!orderId && enabled,
    staleTime:0,
  })
}
